import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router"
import { Tag } from "src/openapi"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import "./tag_table.scss"
import { TableContainer } from "@mui/material"

interface Props {
  data: Tag[]
  companyId: number
}
export const TagTable = ({ data, companyId }: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "tag" })

  const navigate = useNavigate()

  const [hoverIndex, setHoverIndex] = useState<number>()

  return (
    <TableContainer
      style={{
        width: "100%",
        height: "calc(100vh - 185px)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Table className="tag_table" sx={{}}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: "120px" }}>{t("tag_name")}</TableCell>
            <TableCell sx={{ width: "120px" }}>{t("creator")}</TableCell>
            <TableCell sx={{ width: "50px" }}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.length == 0 ? (
            <TableRow>
              <TableCell colSpan={3} sx={{ textAlign: "center" }}>
                {t("no_data")}
              </TableCell>
            </TableRow>
          ) : (
            data.map((row, index) => {
              return (
                <TableRow
                  key={`${row.id}`}
                  onMouseEnter={() => setHoverIndex(index)}
                  onMouseLeave={() => setHoverIndex(undefined)}
                  className={`${index === hoverIndex ? "td-hover" : ""}`}
                  onClick={() => {
                    navigate(`/company/${companyId}/tag/edit/${row.id}`)
                  }}
                >
                  <TableCell>{row.tag}</TableCell>
                  <TableCell>{`${row.author?.lastName} ${row.author?.firstName}`}</TableCell>
                  <TableCell className="edit_tag">{t("edit")}</TableCell>
                </TableRow>
              )
            })
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
